import { useEffectOnce } from 'react-use';
import { useThree } from '@react-three/fiber';
import * as Sentry from '@sentry/react';
import config from 'config';

export const useSentryGpuContext = () => {
  const { gl } = useThree();

  useEffectOnce(() => {
    if (config.USE_SENTRY) {
      const context = gl.getContext();
      const debugInfo = context.getExtension('WEBGL_debug_renderer_info');

      if (debugInfo?.UNMASKED_RENDERER_WEBGL && debugInfo?.UNMASKED_VENDOR_WEBGL) {
        Sentry.getCurrentScope().setContext('gpu', {
          name: context.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL),
          vendor: context.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
        });
      }
    }
  });
};
